import { qk, queryClient } from './queryClient';

/** t128: a job title lives on the workspace membership, so every list that shows it refreshes after a change. */
export function invalidateJobTitle(ws: string, userId: string) {
  for (const queryKey of [['person', ws, userId], qk.members(ws), qk.me, ['people-directory', ws], ['staff-directory', ws], ['members-all', ws], qk.wf(ws, 'employees')]) {
    void queryClient.invalidateQueries({ queryKey });
  }
}
